export class ApiError extends Error {
  constructor(message: string, public status: number) { super(message); }
}
export async function api<T>(path: string, options: RequestInit = {}): Promise<T> {
  const response = await fetch('/api' + path, { credentials: 'same-origin', ...options,
    headers: options.body && !(options.body instanceof FormData)
      ? {'Content-Type': 'application/json', ...options.headers} : options.headers });
  if (!response.ok) {
    const error = await response.json().catch(() => ({}));
    if (response.status === 401 && path !== '/login') window.dispatchEvent(new Event('session-expired'));
    const detail = typeof error.detail === 'string' ? error.detail : 'Не удалось выполнить запрос.';
    throw new ApiError(detail, response.status);
  }
  return response.json() as Promise<T>;
}
export function upload(data: FormData, onProgress: (value: number) => void, signal: AbortSignal): Promise<{id: string}> {
  return new Promise((resolve, reject) => {
    const xhr = new XMLHttpRequest();
    xhr.open('POST', '/api/inspections');
    xhr.withCredentials = true;
    const abort = () => xhr.abort();
    signal.addEventListener('abort', abort, {once: true});
    xhr.upload.onprogress = event => { if (event.lengthComputable) onProgress(Math.round(event.loaded * 100 / event.total)); };
    xhr.onloadend = () => signal.removeEventListener('abort', abort);
    xhr.onerror = () => reject(new Error('Нет связи с сервером. Файл остаётся выбранным — можно повторить загрузку.'));
    xhr.onabort = () => reject(new Error('Загрузка отменена.'));
    xhr.onload = () => {
      let body;
      try { body = JSON.parse(xhr.responseText); } catch { reject(new Error('Сервер вернул некорректный ответ.')); return; }
      if (xhr.status >= 200 && xhr.status < 300) resolve(body);
      else {
        if (xhr.status === 401) window.dispatchEvent(new Event('session-expired'));
        reject(new Error(typeof body.detail === 'string' ? body.detail : 'Не удалось загрузить файл.'));
      }
    };
    if (signal.aborted) { reject(new Error('Загрузка отменена.')); return; }
    xhr.send(data);
  });
}
